import { memo } from 'react'

export const CrewChatDivider = memo(() => (
  // 表示領域内で両端に余白を持たせるためpx-2を指定する
  // 単にhrタグを使用していないのは、borderの上下に余白を持たせるため
  <div className="h-2 px-2">
    <div className="w-full h-1 border-b crew-border-gray"></div>
  </div>
))
